// theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: '"Kanit", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    height: "100%",
                },
                body: {
                    margin: 0,
                    height: "100%",
                    fontFamily: '"Kanit", "Roboto", "Helvetica", "Arial", sans-serif',
                    backgroundColor: "#f8f9fa",
                    overscrollBehavior: "contain",
                    color: "#212121",
                },
                "#root": {
                    minHeight: "100vh",
                    overflowY: "auto",
                },
            },
        },
    },
});

export default theme;
